module.exports = __webpack_public_path__ + "media/40.f21aefb6.mp3";